export default __webpack_public_path__ + "static/media/custom-print-center-point.00f096ff.svg";